import React from 'react';
import './SectionCard.css';

function SectionCard({ section, onClick }) {
  const isExternal = !!section.externalUrl;

  return (
    <div 
      className={`section-card ${isExternal ? 'external' : ''}`}
      onClick={onClick}
    >
      <div className="section-icon">{section.icon}</div>
      <h3 className="section-name">{section.name}</h3>
      <p className="section-description">{section.description}</p>
      {isExternal && (
        <span className="external-link-badge">Opens in new tab →</span>
      )}
      <span className="section-arrow">→</span>
    </div>
  );
}

export default SectionCard;